<template>
  <b-modal
    modal-class="component-modal-product"
    id="productHistoryItemModal"
    ref="productHistoryItemModal"
    size="xl"
    :title="modalTitle"
    no-close-on-backdrop
    @close="close"
    hide-footer
    scrollable
  >
    <b-table
      id="productHistoryTable"
      ref="productHistoryTable"
      hover
      small
      sort-icon-left
      head-variant="light"
      :items="productHistoryData"
      :fields="fields"
      :filter="filter"
      :sort-desc="true"
      :responsive="true"
    >
      <template v-slot:cell(index)="row">{{ row.index + 1 }}.</template>
    </b-table>

    <Dialog ref="Dialog"></Dialog>
    <Loading v-if="isLoading"></Loading>
  </b-modal>
</template>

<script>
import Dialog from "@/components/modal/Dialog";
import Loading from "@/components/Loading";
import "@/theme/modal/ProductAndStock/Product.scss";
import moment from "moment";

export default {
  name: "ProductHistoryItemModal",
  components: {
    Dialog,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      modalTitle: "ประวัติการจัดการสต๊อก",
      productHistoryData: [],
      productUnit: "",
      fields: [
        {
          key: "index",
          label: "",
        },
        {
          key: "detailStock",
          label: "รายละเอียดการจัดการ",
        },
        {
          key: "reasonStock",
          label: "เหตุผล",
        },
        {
          key: "managedByStock",
          label: "จัดการโดย",
        },
        {
          key: "dateTimeStock",
          label: "วัน เวลาที่จัดการ",
        },
        {
          key: "adjustQtyStock",
          label: "จำนวนปรับปรุง",
        },
        {
          key: "unitStock",
          label: "หน่วยสินค้า",
        },
      ],
      filter: null,
    };
  },
  methods: {
    show(data) {
      const { historyData, productUnit } = data;
      this.productUnit = productUnit;
      this.adjustProductHistoryData(historyData);
      this.$bvModal.show("productHistoryItemModal");
    },
    close() {
      this.$bvModal.hide("productHistoryItemModal");
    },
    adjustProductHistoryData(data) {
      this.productHistoryData = data.map(item => {
        const detailAndReason = this.mapProductHistoryDetail(item);
        return {
          detailStock: detailAndReason.detailStock,
          reasonStock: detailAndReason.reasonStock,
          managedByStock: this.formatName(item.creationUser),
          dateTimeStock: this.formatDate(item.creationDt),
          adjustQtyStock: item.qtyBaseUom,
          unitStock: this.productUnit,
        };
      });
    },
    formatName(name) {
      return `${name.firstNameTh} ${name.lastNameTh}`;
    },
    formatDate(date) {
      if (date) {
        return moment(date).locale("th").format("D MMM YY HH:mm");
      } else {
        return "";
      }
    },
    mapProductHistoryDetail(data) {
      const detailType = data.docType;
      const doc = data.doc;

      switch (detailType) {
        case "ADJUSTMENT":
          return {
            detailStock: "ปรับปรุงทั่วไป",
            reasonStock: doc.reason || "-",
          };

        case "TREATMENT":
          return {
            detailStock: "สินค้าถูกใช้งาน ผ่านการรักษา",
            reasonStock: "-",
          };

        case "GOOD_RECEIVE":
          return {
            detailStock: "รับสินค้าเข้าผ่านใบรับสินค้า",
            reasonStock: "-",
          };

        case "TRANSFER":
          return this.getTransferDetail(data, doc);

        default:
          return {
            detailStock: "-",
            reasonStock: "-",
          };
      }
    },
    getTransferDetail(data, doc) {
      const isOut = data.branchId === doc.fromBranchId;
      return {
        detailStock: isOut ? "โอนสินค้าออก" : "รับโอนสินค้าเข้า",
        reasonStock: doc.reason || "-",
      };
    },
  },
};
</script>
